export default __webpack_public_path__ + "static/media/1936.cc3aa9de.png";